class MessageResponse {
    public Id: string;
    public Subject: string;
    public Body: string;
    public IsDraft: boolean;
    public SendDate: Date;
    public ParticipantId: string;
    public PatientProfileId: string;
    public CreatedDate: Date;
    public CreatedBy: string;
    public LastUpdatedDate: Date;
    public LastUpdatedBy: string;

    public constructor(fields?: Partial<MessageResponse>) {
        (Object as any).assign(this, fields);
    }
}

export { MessageResponse };
